import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { months } from 'src/constants';
import { getDataFormat } from 'src/helpers';

import s from './style.module.scss';

const BlackModern = ({ setOnRendered }) => {
  const { currentResume } = useSelector((state) => state.templatesReducer);

  const { image } = currentResume;

  useEffect(() => {
    const img = document.getElementById('avatar');
    if (img) {
      const imgAvatar = document.getElementById('avatar');
      imgAvatar.onload = () => {
        setOnRendered(true);
      };
    } else {
      setOnRendered(true);
    }
  }, []);

  return (
    <>
      {currentResume && (
        <div className={s.cari}>
          {image && (
            <div className={s.avatar__wrap}>
              <div className={s.avatar}>
                <img width={210} src={image} alt="avatar" id="avatar" />
              </div>
            </div>
          )}
          <div className={s.title__wrap}>
            <div className={s.title}>
              {currentResume.firstName} {currentResume.lastName}
            </div>
            <div className={s.title2}>{currentResume.jobTitle}</div>
          </div>
          <div className={s.cari__left}>
            <div className="section-col">
              <div className={`section ${s.section}`}>
                <div className={s.about}>
                  <div className={s.name}>Contacts</div>

                  <div className={s.about__block}>
                    <div className={s.title__left}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        clipRule="evenodd"
                        fillRule="evenodd"
                        imageRendering="optimizeQuality"
                        shapeRendering="geometricPrecision"
                        textRendering="geometricPrecision"
                        viewBox="0 0 4638.14 4638.14"
                        width={25}
                        height={25}
                      >
                        <g>
                          <path
                            d="M2291.9 1703.07c0,-99.22 24.79,-108.71 117.76,-108.71 132,0 255.35,53.74 351.67,119.39 279.02,190.14 356.1,632.5 219.04,632.5 -206.11,0 -13.23,-191.5 -251.34,-428.08 -63.05,-62.64 -106.84,-94.35 -200.27,-125.84 -41.59,-14.02 -81.77,-23.04 -137.49,-25.57 -38.18,-1.73 -99.37,-17.08 -99.37,-63.68zm-1331.66 -226.47c0,-168.75 65.23,-300.88 172.37,-362.11 46.72,-26.7 335.41,-154.25 389.28,-154.25 125.08,0 183.23,145.11 247.38,259.91 32.11,57.46 59.37,103.8 93,160.65 54.25,91.72 132.53,207.12 20.18,311.41 -26.68,24.76 -65.33,41.78 -96.85,66.21 -100.54,77.95 -138.18,224.22 -76.22,355.03l140.9 185.22c19.17,20.09 19.92,25.04 36.68,44.85 15.46,18.28 23.03,22.55 38.75,42.78 58.54,75.37 172.53,178.43 241.63,247.55 63.31,63.34 298.07,269.24 363.65,297.65 265.41,115.01 379.79,-138.11 414.98,-175.79 129.01,-138.18 289.04,10.89 472.03,113.14 55.71,31.13 108.98,61.93 160.94,92.71 166.32,98.54 81.52,238.24 10.93,401.81 -34.15,79.13 -67.64,164.73 -127.04,217.19 -193.19,170.64 -569.16,76.74 -796.48,-32.53 -84.41,-40.58 -144.99,-66.01 -227.86,-116.38 -166.51,-101.23 -350,-225.39 -493.1,-358.43l-181.1 -163.14c-36.01,-31.53 -49.41,-58.36 -81.41,-90.71 -231.83,-234.3 -355.79,-415.31 -514.68,-690.15l-111.02 -233.22c-43.4,-111.01 -96.92,-294.7 -96.92,-419.43zm1331.66 -280.83c0,-97.56 27.18,-108.71 135.88,-108.71 209.28,0 478.4,101.75 627.71,214.76 57.61,43.6 107.85,81.36 158.25,131.64 27.26,27.19 38.02,44.45 63.25,72.63 251.27,280.61 354.28,840.15 210.68,840.15 -34.29,0 -97.65,7.48 -108.03,-73.16 -5.86,-45.55 -6.45,-89.61 -10.52,-134.42 -20.17,-222.25 -134.59,-430.56 -286.84,-582.81 -48.81,-48.81 -92.31,-90.15 -153.3,-127.52 -395.27,-242.16 -637.08,-112.79 -637.08,-232.57z"
                            stroke="rgb(253, 253, 253)"
                            strokeMiterlimit="22.926"
                            strokeWidth="6.85"
                            fill=" #2b2a29"
                          />
                          <path
                            d="M2291.9 1703.07c0,-99.22 24.79,-108.71 117.76,-108.71 132,0 255.35,53.74 351.67,119.39 279.02,190.14 356.1,632.5 219.04,632.5 -206.11,0 -13.23,-191.5 -251.34,-428.08 -63.05,-62.64 -106.84,-94.35 -200.27,-125.84 -41.59,-14.02 -81.77,-23.04 -137.49,-25.57 -38.18,-1.73 -99.37,-17.08 -99.37,-63.68zm-1331.66 -226.47c0,-168.75 65.23,-300.88 172.37,-362.11 46.72,-26.7 335.41,-154.25 389.28,-154.25 125.08,0 183.23,145.11 247.38,259.91 32.11,57.46 59.37,103.8 93,160.65 54.25,91.72 132.53,207.12 20.18,311.41 -26.68,24.76 -65.33,41.78 -96.85,66.21 -100.54,77.95 -138.18,224.22 -76.22,355.03l140.9 185.22c19.17,20.09 19.92,25.04 36.68,44.85 15.46,18.28 23.03,22.55 38.75,42.78 58.54,75.37 172.53,178.43 241.63,247.55 63.31,63.34 298.07,269.24 363.65,297.65 265.41,115.01 379.79,-138.11 414.98,-175.79 129.01,-138.18 289.04,10.89 472.03,113.14 55.71,31.13 108.98,61.93 160.94,92.71 166.32,98.54 81.52,238.24 10.93,401.81 -34.15,79.13 -67.64,164.73 -127.04,217.19 -193.19,170.64 -569.16,76.74 -796.48,-32.53 -84.41,-40.58 -144.99,-66.01 -227.86,-116.38 -166.51,-101.23 -350,-225.39 -493.1,-358.43l-181.1 -163.14c-36.01,-31.53 -49.41,-58.36 -81.41,-90.71 -231.83,-234.3 -355.79,-415.31 -514.68,-690.15l-111.02 -233.22c-43.4,-111.01 -96.92,-294.7 -96.92,-419.43zm1331.66 -280.83c0,-97.56 27.18,-108.71 135.88,-108.71 209.28,0 478.4,101.75 627.71,214.76 57.61,43.6 107.85,81.36 158.25,131.64 27.26,27.19 38.02,44.45 63.25,72.63 251.27,280.61 354.28,840.15 210.68,840.15 -34.29,0 -97.65,7.48 -108.03,-73.16 -5.86,-45.55 -6.45,-89.61 -10.52,-134.42 -20.17,-222.25 -134.59,-430.56 -286.84,-582.81 -48.81,-48.81 -92.31,-90.15 -153.3,-127.52 -395.27,-242.16 -637.08,-112.79 -637.08,-232.57zm-2291.9 1041.77c0,349.73 19.2,539.32 132.38,864.1 53.98,154.92 103.24,243.55 178.7,382.95 17.49,32.32 33.62,53.89 51.7,84.18 362.14,606.43 1151.52,1069.37 1874.76,1069.37l12.28 0c255.72,-0.06 378.13,-2.36 636.45,-66.92 77.97,-19.49 142.55,-40.08 215.37,-65.45 297.17,-103.56 479.5,-231.81 712.16,-411.13 464.6,-358.1 824.34,-1084.05 824.34,-1694.03 0,-418.27 -49.36,-719.55 -214.28,-1063.03 -250.86,-522.48 -605.26,-861.64 -1117.34,-1120.2 -244.91,-123.66 -628.1,-217.38 -905.92,-217.38 -349.14,0 -539.69,19.33 -864.1,132.38 -64.66,22.54 -140.3,52.41 -198.88,81.95l-268.25 148.46c-610,364.28 -1069.37,1152.16 -1069.37,1874.76z"
                            fill="rgb(253, 253, 253)"
                          />
                        </g>
                      </svg>
                    </div>
                    <div className={s.about__block__right}>{currentResume.phone}</div>
                  </div>

                  <div className={s.about__block}>
                    <div className={s.title__left}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        clipRule="evenodd"
                        fillRule="evenodd"
                        imageRendering="optimizeQuality"
                        shapeRendering="geometricPrecision"
                        textRendering="geometricPrecision"
                        viewBox="0 0 3096.95 3096.95"
                        width={25}
                        height={25}
                      >
                        <g>
                          <path
                            d="M1354.91 1681.55c21.65,32.34 100.15,91.45 131.43,122.62 39.06,38.92 85.19,38.92 124.26,0 18.1,-18.03 28.09,-23.36 45.31,-39.38 27.23,-25.34 69.13,-57.86 86.12,-83.24 118.98,79.67 367.1,287.03 504.69,390.52 17,12.79 24.15,19.86 40.53,32.06l77.8 61.32 -1633.16 0 623.02 -483.9zm1143.21 -659.31l0 1064.58c-22.07,-5.89 -343.71,-263.16 -356.04,-273.03l-122.6 -95.15c-26.21,-20.91 -51.81,-41.5 -77.77,-61.35 -20.12,-15.38 -67.3,-55.76 -84.75,-60.42 8.82,-33.04 50.97,-53.55 74.13,-77.09l240.4 -213.25c16.7,-12.75 22.2,-20.4 37.73,-34.85 16.44,-15.3 25.53,-19 42.45,-36.19 26.12,-26.55 228.99,-208.59 246.45,-213.25zm-1899.3 1064.58l0 -1064.58c20.63,5.51 323.49,279.43 361.3,316.15l122.6 107.25c27.62,21.08 150.55,126.07 157.27,151.22 -21.3,5.69 -131.26,98.66 -159,119.24l-438.42 341.87c-13.24,11.04 -26.81,24.31 -43.75,28.84zm114.92 -1155.31l1669.45 0 -285.19 253.15c-10.4,8.3 -15.1,14.05 -24.72,23.68 -17.96,17.98 -32.07,26.49 -51.44,45.34l-81.12 70.1c-10.4,8.3 -15.1,14.05 -24.72,23.67l-367.55 322c-14,-9.38 -39.96,-30.89 -52.96,-43.82l-208.76 -184.41c-9.56,-9.28 -14.08,-15.43 -24.36,-24.03 -12.3,-10.29 -14.57,-9.77 -27,-21.39l-130.27 -117.73c-12.22,-10.23 -14.66,-9.87 -27.02,-21.37l-364.37 -325.19z"
                            stroke="rgb(253, 253, 253)"
                            strokeMiterlimit="22.926"
                            strokeWidth="4.57"
                            fill=" #2b2a29 "
                          />
                          <path
                            d="M1354.91 1681.55c21.65,32.34 100.15,91.45 131.43,122.62 39.06,38.92 85.19,38.92 124.26,0 18.1,-18.03 28.09,-23.36 45.31,-39.38 27.23,-25.34 69.13,-57.86 86.12,-83.24 118.98,79.67 367.1,287.03 504.69,390.52 17,12.79 24.15,19.86 40.53,32.06l77.8 61.32 -1633.16 0 623.02 -483.9zm1143.21 -659.31l0 1064.58c-22.07,-5.89 -343.71,-263.16 -356.04,-273.03l-122.6 -95.15c-26.21,-20.91 -51.81,-41.5 -77.77,-61.35 -20.12,-15.38 -67.3,-55.76 -84.75,-60.42 8.82,-33.04 50.97,-53.55 74.13,-77.09l240.4 -213.25c16.7,-12.75 22.2,-20.4 37.73,-34.85 16.44,-15.3 25.53,-19 42.45,-36.19 26.12,-26.55 228.99,-208.59 246.45,-213.25zm-1899.3 1064.58l0 -1064.58c20.63,5.51 323.49,279.43 361.3,316.15l122.6 107.25c27.62,21.08 150.55,126.07 157.27,151.22 -21.3,5.69 -131.26,98.66 -159,119.24l-438.42 341.87c-13.24,11.04 -26.81,24.31 -43.75,28.84zm114.92 -1155.31l1669.45 0 -285.19 253.15c-10.4,8.3 -15.1,14.05 -24.72,23.68 -17.96,17.98 -32.07,26.49 -51.44,45.34l-81.12 70.1c-10.4,8.3 -15.1,14.05 -24.72,23.67l-367.55 322c-14,-9.38 -39.96,-30.89 -52.96,-43.82l-208.76 -184.41c-9.56,-9.28 -14.08,-15.43 -24.36,-24.03 -12.3,-10.29 -14.57,-9.77 -27,-21.39l-130.27 -117.73c-12.22,-10.23 -14.66,-9.87 -27.02,-21.37l-364.37 -325.19zm-713.75 568.58c0,230.3 14.2,358.02 88.39,570.92 36.05,103.44 68.94,162.62 119.32,255.7 11.68,21.58 22.45,35.99 34.52,56.21 241.8,404.92 768.89,714.03 1251.8,714.03l8.2 0c170.75,-0.04 252.48,-1.57 424.96,-44.69 52.06,-13.01 95.18,-26.76 143.81,-43.7 198.42,-69.15 320.17,-154.78 475.52,-274.52 310.26,-239.14 550.42,-724.03 550.42,-1131.12 0,-279.29 -32.96,-480.45 -143.07,-709.8 -167.51,-348.87 -404.14,-575.33 -746.06,-747.97 -163.53,-82.57 -419.39,-145.15 -604.9,-145.15 -233.13,0 -360.36,12.91 -576.97,88.39 -43.18,15.05 -93.68,35 -132.79,54.72l-179.12 99.13c-83.67,49.96 -195.21,143.23 -261.89,209.91 -269.34,269.34 -452.14,665.72 -452.14,1047.94z"
                            fill="rgb(253, 253, 253)"
                          />
                        </g>
                      </svg>
                    </div>
                    <div className={s.about__block__right}>{currentResume.email}</div>
                  </div>

                  <div className={s.about__block}>
                    <div className={s.title__left}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        clipRule="evenodd"
                        fillRule="evenodd"
                        imageRendering="optimizeQuality"
                        shapeRendering="geometricPrecision"
                        textRendering="geometricPrecision"
                        viewBox="0 0 3759.91 3759.91"
                        width={25}
                        height={25}
                      >
                        <g>
                          <path
                            d="M1094.19 2026.82c0,-22.07 163.55,-174.56 189.1,-200.11 76.1,-76.1 559.49,-568.1 596.66,-592.99 45.13,30.22 149.94,146.26 196.44,192.77l495.69 495.69c18.73,18.73 93.63,80.8 93.63,104.65l0 793.11 -1571.52 0 0 -793.11zm-137.71 -152.4l-106.29 -110.31 1027.93 -1031.58 1031.76 1028.1 -110.21 113.76 -917.89 -921.55 -925.3 921.59z"
                            stroke="rgb(253, 253, 253)"
                            strokeMiterlimit="22.926"
                            strokeWidth="5.2"
                            fill=" #2b2a29"
                          />
                          <path
                            d="M1094.19 2026.82c0,-22.07 163.55,-174.56 189.1,-200.11 76.1,-76.1 559.49,-568.1 596.66,-592.99 45.13,30.22 149.94,146.26 196.44,192.77l495.69 495.69c18.73,18.73 93.63,80.8 93.63,104.65l0 793.11 -1571.52 0 0 -793.11zm705.26 -2026.82l184.45 0c237.15,11.67 472.66,68.53 691.7,173.7 404.98,194.45 723.25,506.39 912.99,915.56 125.12,269.83 171.31,502.36 171.31,842.1 0,706.37 -461.36,1366.07 -1089.26,1657.23 -228.59,106 -482.14,163.64 -737.19,171.31l-117.23 0c-253.76,-7.63 -505.45,-64.97 -731.92,-173.7 -105.76,-50.78 -195.98,-102.5 -286.97,-168.33 -272.84,-197.39 -478.7,-429.53 -626.02,-747.22 -125.12,-269.83 -171.31,-502.36 -171.31,-842.1 0,-478.96 227.25,-957.93 548.93,-1279.62 335.84,-335.84 789.06,-526.47 1250.52,-548.93zm-842.97 1874.42l-106.29 -110.31 1027.93 -1031.58 1031.76 1028.1 -110.21 113.76 -917.89 -921.55 -925.3 921.59z"
                            fill="rgb(253, 253, 253)"
                          />
                        </g>
                      </svg>
                    </div>
                    <div className={s.about__block__right}>
                      <div>
                        {currentResume.country.name}, {currentResume.city.name}
                      </div>

                      <div>
                        {currentResume.state} {currentResume.zip}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {currentResume.languages.length > 0 && (
                <div className={`section ${s.section}`}>
                  <div className={s.about}>
                    <div className={s.name}>Languagess</div>
                    {currentResume.languages.map((item) => (
                      <div className={s.skill} key={item.id}>
                        {item.language} - {item.proficiency}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {currentResume.hardSkills.length > 0 && (
                <div className={`section ${s.section}`}>
                  <div className={s.about}>
                    <div className={s.name}>Hard skills</div>
                    {currentResume.hardSkills.map((item) => (
                      <div className={s.skill} key={item.id}>
                        {item.skill}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {currentResume.softSkills.length > 0 && (
                <div className={`section ${s.section}`}>
                  <div className={s.about}>
                    <div className={s.name}>Soft skills</div>
                    {currentResume.softSkills.map((item) => (
                      <div className={s.skill} key={item.id}>
                        {item.skill}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className={s.cari__right}>
            <div className="section-col">
              {currentResume.experiences.length > 0 && (
                <div className={`section ${s.section}`}>
                  {currentResume.experiences.map((item) => (
                    <div className={`sub-section ${s.work__sub__section}`} key={item.id}>
                      <div className={s.work}>
                        <div className={s.work__title}>Experiences</div>

                        <div className={s.work__wrap}>
                          <div className={s.work__job}>{item.jobTitle}</div>
                          <div className={s.work__top}>
                            <div className={s.work__name}>{item.companyName}</div>

                            <div className={s.work__data}>
                              <div className={s.work__data__col}>
                                {getDataFormat(item.startDate)}
                              </div>
                              -
                              <div className={s.work__data__col}>
                                {item.isPresent ? 'Present' : getDataFormat(item.endDate)}
                              </div>
                            </div>
                          </div>

                          <div className={s.text}>{item.responsibilities}</div>
                          <div className={s.text}>{item.achievements}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {currentResume.educations.length > 0 && (
                <div className={`section ${s.section}`}>
                  {currentResume.educations.map((item) => (
                    <div className={`sub-section ${s.work__sub__section}`} key={item.id}>
                      <div className={s.work}>
                        <div className={s.work__title}>Education</div>

                        <div className={s.work__wrap}>
                          <div className={s.work__top}>
                            <div className={s.work__job}>{item.universityName}</div>
                            <div className={s.work__data}>
                              <div className={s.work__data__col}>
                                {months[item.graduationMonth].name} {item.graduationYear}
                              </div>
                            </div>
                          </div>

                          <div className={s.work__name}>
                            {item.country.name}, {item.city.name}
                          </div>

                          <div className={s.text}>{item.achievements}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {currentResume.hobbies.length > 0 && (
                <div className={`section ${s.section}`}>
                  {currentResume.hobbies.map((item) => (
                    <div className={`sub-section ${s.work__sub__section}`} key={item.id}>
                      <div className={s.work}>
                        <div className={s.work__title}>Hobbies</div>

                        <div className={s.work__wrap}>
                          <div className={s.work__job}>{item.name}</div>

                          <div className={s.text}>{item.description}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {currentResume.certificates.length > 0 && (
                <div className={`section ${s.section}`}>
                  {currentResume.certificates.map((item) => (
                    <div className={`sub-section ${s.work__sub__section}`} key={item.id}>
                      <div className={s.work}>
                        <div className={s.work__title}>Certifications</div>

                        <div className={s.work__wrap}>
                          <div className={s.work__job}>{item.name}</div>

                          <div className={s.text}>{item.skills}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

BlackModern.propTypes = {
  setOnRendered: PropTypes.func.isRequired,
};
export default BlackModern;
